import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { ExtendedProgressStatusDto, ProgressStatusListDto, ProgressStatusParams } from './progress-statuses.schema';
import { queryOptions } from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { progressStatusesApi } from './progress-statuses.api';

export const progressStatusesQueryOptions = {
  /**
   * Fetch progress statuses list.
   */
  list: (params?: ProgressStatusParams, options?: QueryOptionsOverride<ProgressStatusListDto>) => queryOptions({
    queryKey: [QueriesKeys.progressStatuses, params],
    queryFn: () => progressStatusesApi.getAll(params),
    ...options,
  }),

  /**
   * Fetch progress status by ID.
   */
  byId: (id: string, options?: QueryOptionsOverride<ExtendedProgressStatusDto>) => queryOptions({
    queryKey: [QueriesKeys.progressStatuses, id],
    queryFn: () => progressStatusesApi.getById(id),
    ...options,
  }),
};
